const dotenv = require('dotenv').config();

export default {
    ENV: process.env.VUE_APP_ENV || 'local_development',
    BASE: process.env.VUE_APP_URL_API
};




//////////////////
// WEBPACK FOOTER
// ./config/configEnv.js
// module id = null
// module chunks = 